import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=789a0681&lang=pug&"
import script from "./edit.vue?vue&type=script&setup=true&lang=js&"
export * from "./edit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports